import { SortingState } from '@tanstack/react-table';
import { createParser } from 'nuqs';

// Custom parser for TanStack Table sorting state
export const parseAsSortingState = createParser({
  parse(queryValue: string): SortingState | null {
    try {
      const parsed = JSON.parse(queryValue);

      // Validate that it's an array of sorting objects
      if (!Array.isArray(parsed)) {
        return null;
      }

      // Validate each sorting item
      for (const item of parsed) {
        if (
          typeof item !== 'object' ||
          item === null ||
          typeof item.id !== 'string' ||
          typeof item.desc !== 'boolean'
        ) {
          return null;
        }
      }

      return parsed as SortingState;
    } catch {
      return null;
    }
  },
  serialize(value: SortingState): string {
    return JSON.stringify(value);
  },
});
